import { Map } from 'immutable';
import Constants from '../../constants';
import { viewReducerReplacer } from '../helpers/views';

export const DEFAULT_STATE = Map({});

const filteredSpaces = viewReducerReplacer([Constants.QUERY_SPACES], 'spaces', DEFAULT_STATE);

export default filteredSpaces;
